<template>
	<div>
		<div v-if="!editing" class="level">
			<div class="level-left">
				<button
					class="level-item button is-text"
					data-test="set-name"
					@click="setEdit(true)"
				>
					<dc-icon icon="pencil"></dc-icon>
					<span v-if="title" data-test="token-name">{{ title }}</span>
					<span v-else data-test="token-name">Set name</span>
				</button>
				<transition name="fade">
					<div
						v-show="success"
						class="level-item has-text-success"
						data-test="token-update-success"
					>
						Token name updated successfully
					</div>
				</transition>
			</div>
		</div>
		<form v-if="editing" class="field is-grouped" @submit.prevent="submit">
			<p class="control is-expanded">
				<input
					v-model.trim="$v.apikey.name.$model"
					class="input"
					type="text"
					data-test="token-name-input"
				/>
			</p>
			<p class="control">
				<button
					class="button is-success"
					:disabled="isValid"
					:class="{ 'is-loading': fetching }"
					data-test="token-name-save"
				>
					Save
				</button>
			</p>
			<p class="control">
				<a
					class="button"
					data-test="token-name-cancel"
					@click="cancelEdit"
				>
					Cancel
				</a>
			</p>
		</form>
	</div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { mapActions, mapGetters } from "vuex";
export default {
	name: "TokenName",
	mixins: [validationMixin],
	props: {
		token: {
			type: Object,
			default: () => null
		}
	},
	validations: {
		apikey: {
			name: { required }
		}
	},
	data() {
		return {
			editing: false,
			success: false,
			apikey: {
				name: ""
			}
		};
	},
	computed: {
		...mapGetters({
			fetching: "userTokensModule/fetching"
		}),
		isValid() {
			return this.$v.$invalid;
		},
		title() {
			return this.apikey.name;
		}
	},
	mounted() {
		this.apikey = JSON.parse(JSON.stringify(this.token));
	},
	methods: {
		...mapActions({
			update: "userTokensModule/update"
		}),
		cancelEdit() {
			this.apikey.name = this.token.name;
			this.setEdit(false);
		},
		setEdit(state) {
			this.$v.$touch();
			this.editing = state;
		},
		async submit() {
			await this.update(this.apikey);
			this.editing = false;
			this.success = true;
			setTimeout(() => {
				this.success = false;
			}, 1500);
		}
	}
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.2s ease-out;
}
.fade-enter,
.fade-leave-to {
	opacity: 0;
}
</style>
